import type { CSSProperties } from 'react';
import type { CatalogSection } from '../../api/catalogApi';
import { CH, char } from './art';
import Raw from './Raw';

// [character index in CH, march duration (s), animation delay (s)]
const MARCHERS: [number, number, number][] = [
  [0, 26, 0],
  [3, 22, -4],
  [6, 30, -9],
  [9, 24, -2],
  [12, 27, -7],
  [15, 23, -5],
];

export default function SectionHero({ section }: { section: CatalogSection }) {
  const count = section.items.length;
  const sparks = Array.from({ length: 14 }, (_, n) => ({
    size: 3 + ((n * 7) % 6),
    left: (n * 67) % 100,
    duration: 3.5 + (n % 5),
    delay: -(n * 0.6),
  }));

  return (
    <div className="hero">
      <div className="glow" style={{ right: '6%', top: -40 }} />
      <div className="sweep" />
      <div className="band">
        {section.id === 'tools' &&
          MARCHERS.map(([idx, d, dl]) => (
            <Raw
              key={idx}
              className="bch"
              style={{ '--d': `${d}s`, '--dl': `${dl}s` } as CSSProperties}
              html={char(CH[idx])}
            />
          ))}
        {sparks.map((s, n) => (
          <span
            key={n}
            className="spark"
            style={
              {
                width: s.size,
                height: s.size,
                left: `${s.left}%`,
                bottom: 6,
                '--sd': `${s.duration}s`,
                '--sdl': `${s.delay}s`,
              } as CSSProperties
            }
          />
        ))}
      </div>
      <div>
        <h1>{section.name}</h1>
        <p className="lede">{section.lede}</p>
      </div>
      <div className="stats">
        <div className="stat">
          <b>{count}</b>
          <span>Tools</span>
        </div>
        <div className="stat">
          <b>{count}</b>
          <span>Ready</span>
        </div>
        <div className="stat">
          <b>Today</b>
          <span>Last run</span>
        </div>
      </div>
    </div>
  );
}
